export default __webpack_public_path__ + "static/102-718c25fb0f39b90c94d377354bf8ff4b.jpg";